module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._core-js@2.5.0@core-js/modules/_a-function.js
// module id = ../../../../._core-js@2.5.0@core-js/modules/_a-function.js
// module chunks = 2